import {FormControl, Separator} from 'platform/components';
import {VStack, Heading, Show} from 'platform/foundation';

import {useGetTenantQuery} from '@dms/api/core';
import {
  FieldGroupDefinitionResponseBody,
  StageSequenceDefinitionResponseBody,
} from '@dms/api/settings';

import {MandatoryFieldsRequestFormSchemaType} from '../schemas/MandatoryFieldsFormSchema';
import {MandatoryFieldsItem} from './MandatoryFieldsItem';

interface MandatoryFieldsGroupProps {
  fieldGroup: FieldGroupDefinitionResponseBody;
  stageSequences: StageSequenceDefinitionResponseBody[];
  control: FormControl<MandatoryFieldsRequestFormSchemaType>;
  defaultValues: Partial<MandatoryFieldsRequestFormSchemaType>;
  isLast: boolean;
}

export function MandatoryFieldsGroup(props: MandatoryFieldsGroupProps) {
  const {data: tenantData} = useGetTenantQuery();
  const isGermanTenant = tenantData?.country === 'DEU';

  return (
    <VStack spacing={4}>
      <Heading size={4}>{props.fieldGroup.name}</Heading>
      {props.fieldGroup.fields
        .filter((field) => (field.id === 'HSN' || field.id === 'TSN' ? isGermanTenant : true))
        .map((field) => (
          <MandatoryFieldsItem
            key={field.id}
            field={field}
            stageSequences={props.stageSequences}
            control={props.control}
            defaultValues={props.defaultValues}
          />
        ))}
      <Show when={!props.isLast}>
        <Separator />
      </Show>
    </VStack>
  );
}
